import { useEffect } from "react";
import PublicEventsSection from "@/components/PublicEventsSection";

const Events = () => {
  useEffect(() => {
    document.title = "Upcoming Events | Metro City Groove";
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        "content",
        "Browse every published Metro City Groove event — venue, date, time, age restrictions and tickets.",
      );
  }, []);

  return (
    <div className="bg-black text-white">
      <div className="container mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <PublicEventsSection variant="page" />
      </div>
    </div>
  );
};

export default Events;
